import React from 'react';
import FundingCommissionStatusBadge from './FundingCommissionStatusBadge';

const formatCurrency = (value) => {
  if (value == null || value === '') return '—';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value);
};

const formatDate = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

const FundingCommissionTable = ({ commissions, onView, onStatusChange, onDelete, savingId }) => (
  <div className="overflow-x-auto">
    <table className="min-w-full text-left text-sm">
      <thead>
        <tr className="border-b border-[var(--fg-line)] text-[var(--fg-muted)]">
          <th className="px-3 py-2 font-medium">Client</th>
          <th className="px-3 py-2 font-medium">Business</th>
          <th className="px-3 py-2 font-medium">Deal</th>
          <th className="px-3 py-2 font-medium">Lender</th>
          <th className="px-3 py-2 font-medium">Funded</th>
          <th className="px-3 py-2 font-medium">Commission</th>
          <th className="px-3 py-2 font-medium">Status</th>
          <th className="px-3 py-2 font-medium">Payout</th>
          <th className="px-3 py-2 font-medium">Clawback</th>
          <th className="px-3 py-2 font-medium">Due</th>
          <th className="px-3 py-2 font-medium">Paid At</th>
          <th className="px-3 py-2 font-medium">Actions</th>
        </tr>
      </thead>
      <tbody>
        {commissions.map((commission) => (
          <tr key={commission.id} className="border-b border-[var(--fg-line)]/70">
            <td className="px-3 py-3 font-medium text-[var(--fg-text)]">{commission.clientName || '—'}</td>
            <td className="px-3 py-3 text-[var(--fg-muted)]">{commission.businessName || '—'}</td>
            <td className="px-3 py-3 text-xs text-[var(--fg-muted)]">{commission.dealId || '—'}</td>
            <td className="px-3 py-3 text-[var(--fg-muted)]">{commission.lenderName}</td>
            <td className="px-3 py-3">{formatCurrency(commission.fundedAmount)}</td>
            <td className="px-3 py-3 font-medium text-[var(--fg-text)]">{formatCurrency(commission.commissionAmount)}</td>
            <td className="px-3 py-3"><FundingCommissionStatusBadge status={commission.status} /></td>
            <td className="px-3 py-3 text-[var(--fg-muted)]">{commission.payoutStatus || '—'}</td>
            <td className="px-3 py-3 text-[var(--fg-muted)]">{commission.clawbackRisk || '—'}</td>
            <td className="px-3 py-3 text-[var(--fg-muted)]">{formatDate(commission.payoutDueAt)}</td>
            <td className="px-3 py-3 text-[var(--fg-muted)]">{formatDate(commission.paidAt)}</td>
            <td className="px-3 py-3">
              <div className="flex flex-wrap gap-1">
                <button type="button" onClick={() => onView(commission)} className="rounded-lg px-2 py-1 text-xs text-[var(--fg-accent)] hover:bg-[var(--fg-accent-soft)]">View</button>
                {['Earned', 'Pending Payout', 'Paid'].map((status) => (
                  <button
                    key={status}
                    type="button"
                    disabled={savingId === commission.id || commission.status === status}
                    onClick={() => onStatusChange(commission, status)}
                    className="rounded-lg px-2 py-1 text-xs text-[var(--fg-muted)] hover:bg-[var(--fg-panel-soft)] disabled:opacity-40"
                  >
                    {status}
                  </button>
                ))}
                <button type="button" onClick={() => onDelete(commission)} className="rounded-lg px-2 py-1 text-xs text-rose-600 hover:bg-rose-50 dark:hover:bg-rose-950/30">Void</button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default FundingCommissionTable;
